import * as React from "react";
function SvgTransfer(props, svgRef) {
  return <svg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "none",
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path d="M39 51H27V59.5885C27 59.7554 26.8077 59.8489 26.6764 59.7458L6 43.5L26.6764 27.2542C26.8077 27.1511 27 27.2446 27 27.4115V36H45" strokeWidth={1.5} /><path d="M33 21H45V12.4115C45 12.2446 45.1923 12.1511 45.3236 12.2542L66 28.5L45.3236 44.7458C45.1923 44.8489 45 44.7554 45 44.5885V36H27" strokeWidth={1.5} /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "src/assets/icons/transfer.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/transfer_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/transfer_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/transfer_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/transfer_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/transfer_4x.svg"
};
export { ForwardRef as ReactComponent };